import { Component } from 'react';
import PropTypes from 'prop-types';

import Thumb from './Thumb';
import Card from './Card';

class UserList extends Component {
  renderCard(user) {
    const { onDeleteBookmark } = this.props;

    return (
      <Card key={user.id} user={user} onDeleteBookmark={onDeleteBookmark} />
    );
  }

  renderThumb = (user, showDescription) => (
    <Thumb key={user.id} user={user} showDescription={showDescription} />
  );

  render() {
    const { users, showDetails, showDescription } = this.props;

    if (users.length === 0) return null;

    return (
      <div className="grid grid--narrow">
        {users.map((user) =>
          showDetails
            ? this.renderCard(user)
            : this.renderThumb(user, showDescription),
        )}
      </div>
    );
  }
}

UserList.propTypes = {
  users: PropTypes.array,
  showDetails: PropTypes.bool,
  showDescription: PropTypes.bool,
};

UserList.defaultProps = {
  users: [],
  showDetails: false,
  showDescription: false,
  onDeleteBookmark: PropTypes.func,
};

export default UserList;
